/**
 * Constants for step-up authentication
 */

/**
 * Window used by the ambient status poll in StepUpAuthContext (GET context/step-up-status).
 * This is only the freshness the shared context reports on; each gated action passes the window its
 * own endpoint's [RequireStepUp] declares. It is deliberately NOT the backend default of 30.
 */
export const STEP_UP_MAX_AGE_MINUTES = 5;

/**
 * Cooldown period in milliseconds before allowing another automatic redirect
 * Prevents infinite redirect loops
 */
export const REDIRECT_COOLDOWN_MS = 30000; // 30 seconds

/**
 * Maximum number of automatic redirect attempts before showing manual button
 */
export const MAX_REDIRECT_ATTEMPTS = 1;
